import { Action } from '@/_core/fluxstore/types';
import { useLocalStorage } from 'vue-composable';
import { StorymapState } from '../types';
import { useStorymapStore } from '../useModule';

const { registerReducer } = useStorymapStore();

export class SetZoomLevel extends Action<StorymapState> {
    public static ACTION_TYPE = 'SetZoomLevel';

    public constructor(public level: 1 | 2 | 3) {
        super(SetZoomLevel.ACTION_TYPE);
    }
}

const reducer = (state: StorymapState, action: SetZoomLevel): void => {
    state.zoomLevel = action.level;
    const { storage: storedZoomLevel } = useLocalStorage(`_storiesonboard_${state.id}_zoomLevel`, 2);
    storedZoomLevel.value = action.level;
};

//@ts-ignore
registerReducer(SetZoomLevel.ACTION_TYPE, reducer);
